export class CreateReviewError extends Error {}
export class EditReviewError extends Error {}
export class DeleteReviewError extends Error {}
export class FetchReviewsError extends Error {}
